export default "__VITE_ASSET__BTAdqIzQ__"